import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Glyphicon from 'react-bootstrap/lib/Glyphicon';
import Input from '../Input/Input';
import css from './styles.less';

class DropDown extends React.Component {

    state = {
        listVisible: false,
        filter: '',
        selectedIndex: -1,
        filteredList: [],
    }

    select = (item) => {
        this.props.onChange(item);
    }

    show = () => {
        this.setState({
            listVisible: true,
            selectedIndex: -1
        });
        document.addEventListener("click", this.hide);
    }

    hide = () => {
        this.setState({ listVisible: false });
        document.removeEventListener("click", this.hide);
    }

    stopPropagation = (e) => {
        e.stopPropagation();
        e.nativeEvent.stopImmediatePropagation();
    }

    onInputChange = (val) => {
        let filter = val.toLowerCase().trim();
        let list = this.props.list.filter(o => o[this.props.labelName].toLowerCase().trim().indexOf(filter) >= 0);
        this.setState({
            filter: val,
            filteredList: list
        });
        this.select(null);
    }

    renderItem = (t, index) => {
        const { actions, specialLabel, labelName, valueName } = this.props;
        const { selectedIndex } = this.state;

        return (
            <div className={classnames(css.item, selectedIndex == index && css.hovered)}
                key={index}>
                <span className={css.itemLabel}
                    onClick={() => { this.select(t) }}
                >
                    {specialLabel ? specialLabel(t[labelName]) : t[labelName]}</span>
                {actions.map(action =>
                    <div className={css.action}
                        key={action.name}
                        onClick={(e) => { this.stopPropagation(e); action.action(t[valueName]) }}>
                        <span className={`glyphicon glyphicon-${action.name}`}></span>

                    </div>)}
            </div>
        );
    }

    onKeyDown = (e) => {
        const { list } = this.props;
        let { filteredList, selectedIndex } = this.state;
        if (filteredList == null || filteredList.length == 0) {
            filteredList = [...list];
        }
        var length = filteredList.length;
        switch (e.keyCode) {
            case 27: {//escape
                this.hide();
                break;
            }
            case 40: {//arrow down
                if (selectedIndex < length - 1) {
                    this.setState({
                        selectedIndex: ++selectedIndex
                    });
                }
                break;
            }
            case 38: {//arrow up
                if (selectedIndex > 0) {
                    this.setState({
                        selectedIndex: --selectedIndex
                    });
                }
                break;
            }
            case 13: {//enter
                if (selectedIndex > -1 && filteredList != null && filteredList.length > 0) {
                    this.select(filteredList[selectedIndex]);
                    this.hide();
                }
                break;
            }
            default:
                break;
        }
    }

    renderlastItemAction = (t, isEnable) => {
        const { maxItems } = this.props;
        return (
            <div className={classnames(css.item, css.lastAction, !isEnable && css.disabledBtn)}
                key={Object.values(t).toString()}>
                <div className={classnames(css.last, css.action)}
                    key={t.name}
                    onClick={(e) => { this.stopPropagation(e); t.action() }}>
                    <span className={`glyphicon glyphicon-${t.name}`}></span>
                </div>
            </div>
        );
    }

    renderListItems = () => {
        var { list, labelName, lastItemAction, maxItems } = this.props;
        var { filteredList } = this.state;

        if (filteredList == null || filteredList.length == 0) {
            if (Array.isArray(list))
                filteredList = [...list];
            else
                filteredList = [];
        }

        return (
            <div className={css.holder}>
                {lastItemAction && this.renderlastItemAction(lastItemAction, maxItems > filteredList.length)}
                {filteredList.map((t, index) => this.renderItem(t, index))}
            </div>
        );
    }

    render() {

        const {
            labelName,
            isRounded,
            specialLabel,
            direction,
            valueName,
            selectedValue,
            isTypeAhead,
            typeAheadPH,
            list,
        } = this.props;

        const { filter, listVisible } = this.state;
        const selectedObject = (list && list.length > 0) && list.find(t => t[valueName] == selectedValue);
        const specialLabelTitle = specialLabel && selectedObject && specialLabel(selectedObject[labelName]);
        const selectedObjectTitle = selectedObject && selectedObject[labelName] || '';
        let sel = selectedObject && specialLabelTitle ? specialLabelTitle : selectedObjectTitle;
        if (filter != '') {
            sel = filter;
        }

        return (
            <div className={classnames(css.dropdownContainer, css[direction], listVisible && css.show, isRounded && css.roundBorders)}>
                <div className={classnames(css.dropdownDisplay, listVisible && css.clicked)} onClick={this.show}>
                    {isTypeAhead ?

                        (<div className={css.inputDisplayRow}>
                            <Input placeHolder={typeAheadPH}
                                {...this.props}
                                onKeyDown={this.onKeyDown}
                                value={sel}
                                onChange={this.onInputChange}
                            />
                        </div>) :

                        (<div className={css.actionDisplayRow}>
                            <span>{sel}</span>
                            <div className={css.actionHolder}>
                            <span className={`glyphicon glyphicon-triangle-bottom`}></span>

                            </div>
                        </div>)
                    }
                </div>
                <div className={css.dropdownList} ref={(div) => { this.DDListHolder = div; }}>
                    {this.renderListItems()}
                </div>
            </div>
        );
    }
}
DropDown.propTypes = {
    selectedValue: PropTypes.any,
    list: PropTypes.array,
    labelName: PropTypes.string,
    valueName: PropTypes.string,
    direction: PropTypes.oneOf(['left', 'right']),
    onChange: PropTypes.func,
    isRounded: PropTypes.bool,
    actions: PropTypes.array,
    specialLabel: PropTypes.func,
    lastItemAction: PropTypes.shape({
        name: PropTypes.string,
        action: PropTypes.func
    }),
    isTypeAhead: PropTypes.bool,
    typeAheadPH: PropTypes.string,
}

DropDown.defaultProps = {
    actions: [],
    isTypeAhead: false,
    maxItems: 3,
    direction: 'left'
};

export default DropDown;


// WEBPACK FOOTER //
// ./src/components/DropDown/DropDown.js